import React, { useContext, useEffect } from 'react'
import SearchDateDropDown from './SearchDateDropDown'
import DateSelectToggle from 'components/Search/SearchForm/SearchDateInput/DateSelectToggle'
import AnytimeDateTrigger from './AnytimeDateTrigger'
import { GlobalSearchDispatchContext, GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import { DATE_SEARCH_OPTION_IDS } from 'constants/search'
import FlexibleDateTrigger from './FlexibleDateTrigger'
import { DurationOption } from 'components/Search/SearchForm/SearchDateInput/FlexibleDatePicker/DurationPicker'

export interface Props {
  onDateToggle: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onDatesApply: () => void;
  onDatesDecline: () => void;
  isToggled: boolean;
  isLastStep?: boolean;
  anytimeDateSelected?: boolean;
  selectAnytimeDate?: (shouldApply: boolean) => void;
  selectSpecificDates?: () => void;
  selectFlexibleDates?: () => void;
  dateSearchOptionId?: DATE_SEARCH_OPTION_IDS;
  durationOptionsCustom?: DurationOption[];
  isSpecificSearchEnabled?: boolean;
}

function SearchDateInputDesktop({
  onDateToggle,
  isToggled,
  onDatesApply,
  onDatesDecline,
  isLastStep,
  anytimeDateSelected,
  selectAnytimeDate,
  selectSpecificDates,
  selectFlexibleDates,
  dateSearchOptionId,
  durationOptionsCustom,
  isSpecificSearchEnabled = true,
}: Props) {
  const { checkinDate, checkoutDate, flexibleMonths, flexibleNights, userSelectedFlexibleMonths } = useContext(GlobalSearchStateContext)
  const globalSearchDispatch = useContext(GlobalSearchDispatchContext)
  /**
   * When user only select checkin date, and close the dropdown, dismiss that value
   */
  useEffect(() => {
    if (!isToggled) {
      if (!checkinDate || !checkoutDate) {
        globalSearchDispatch({ type: GlobalSearchStateActions.SET_CHECKIN_DATE, date: undefined })
        globalSearchDispatch({ type: GlobalSearchStateActions.SET_CHECKOUT_DATE, date: undefined })
      }
      if (flexibleMonths && flexibleNights) {
        globalSearchDispatch({ type: GlobalSearchStateActions.SET_DATE_SEARCH_OPTION, optionId: DATE_SEARCH_OPTION_IDS.FLEXIBLE })
      }
    }
  }, [
    isToggled,
    checkinDate,
    checkoutDate,
    globalSearchDispatch,
    flexibleMonths,
    flexibleNights,
  ])

  return (
    <>
      {dateSearchOptionId === DATE_SEARCH_OPTION_IDS.ANYTIME && <AnytimeDateTrigger onDateToggle={onDateToggle} />}
      {dateSearchOptionId === DATE_SEARCH_OPTION_IDS.SPECIFIC && <DateSelectToggle
          isToggled={isToggled}
          onDateToggle={onDateToggle}
        />
      }
      {dateSearchOptionId === DATE_SEARCH_OPTION_IDS.FLEXIBLE && <FlexibleDateTrigger onDateToggle={onDateToggle} flexibleMonths={userSelectedFlexibleMonths ? flexibleMonths : undefined } flexibleNightsId={flexibleNights} durationOptionsCustom={durationOptionsCustom} />}
      {isToggled && (
        <SearchDateDropDown
          onDatesApply={onDatesApply}
          onDatesDecline={onDatesDecline}
          isLastStep={isLastStep}
          anytimeDateSelected={anytimeDateSelected}
          selectAnytimeDate={selectAnytimeDate}
          selectSpecificDates={selectSpecificDates}
          selectFlexibleDates={selectFlexibleDates}
          dateSearchOptionId={dateSearchOptionId}
          durationOptionsCustom={durationOptionsCustom}
          isSpecificSearchEnabled={isSpecificSearchEnabled}
        />
      )}
    </>
  )
}

export default SearchDateInputDesktop
